// // src/utils/reportConfigs.js

// const reportConfigs = {
//     survey: {
//     url: "common/surveyexceltableu",
//       schema: [
//         { id: "NAME", dataType: "string" },
//         { id: "EMAILID", dataType: "string" },
//         { id: "COUNTY", dataType: "string" },
//         { id: "DISTRICT", dataType: "string" },
//         { id: "SURVEY_TYPE", dataType: "string" },
//         { id: "SCHOOL_NAME", dataType: "string" },
//         { id: "SCHOOL_ID", dataType: "string" },
//       ],
//       formatData: (data) =>
//         data.map((item) => ({
//           NAME: item.NAME || "",
//           EMAILID: item.EMAILID || "",
//           COUNTY: item.COUNTY || "",
//           DISTRICT: item.DISTRICT || "",
//           SURVEY_TYPE: item["SURVEY TYPE"] || "",
//           SCHOOL_NAME: item["SCHOOL NAME"] || "",
//           SCHOOL_ID: item["SCHOOL ID"] || "",
//         })),
//     },
  
//     dcu: {
//         url:'coordinator/getDistrictExceltableau',
//       schema: [
//         { id: "COUNTY", dataType: "string" },
//         { id: "DISTRICT", dataType: "string" },
//         { id: "FUNDED", dataType: "string" },
//         { id: "FIRST_NAME", dataType: "string" },
//         { id: "LAST_NAME", dataType: "string" },
//         { id: "EMAILID", dataType: "string" },
//         { id: "CREATEDAT", dataType: "datetime" },
//       ],
//       formatData: (data) =>
//         data.map((item) => ({
//           COUNTY: item.COUNTY || "",
//           DISTRICT: item.DISTRICT || "",
//           FUNDED: item.FUNDED || "",
//           FIRST_NAME: item.FIRST_NAME || "",
//           LAST_NAME: item.LAST_NAME || "",
//           EMAILID: item.EMAILID || "",
//           CREATEDAT: item.CREATEDAT || "",
//         })),
//     },
//   };
  
//   export default reportConfigs;
  

// reportConfigs.js
import config from '../../utils/Config';

export const getReportConfig = (reportType) => {
  if (reportType === 'survey') {
    return {
      url: `${config.basePath}common/surveyexceltableu`,
      columns: [
        { id: "NAME", dataType: window.tableau.dataTypeEnum.string },
        { id: "EMAILID", dataType: window.tableau.dataTypeEnum.string },
        { id: "COUNTY", dataType: window.tableau.dataTypeEnum.string },
        { id: "DISTRICT", dataType: window.tableau.dataTypeEnum.string },
        { id: "SURVEY_TYPE", dataType: window.tableau.dataTypeEnum.string },
        { id: "SCHOOL_NAME", dataType: window.tableau.dataTypeEnum.string },
        { id: "SCHOOL_ID", dataType: window.tableau.dataTypeEnum.string },
        { id: "CLOSEDATABY", dataType: window.tableau.dataTypeEnum.string },
        { id: "CLOSEDATAAT", dataType: window.tableau.dataTypeEnum.string },
        { id: "CLOSEDATACTION", dataType: window.tableau.dataTypeEnum.int },
        { id: "CORE_MODULE", dataType: window.tableau.dataTypeEnum.int },
        { id: "BEHAVIORAL_HEALTH", dataType: window.tableau.dataTypeEnum.int },
        { id: "SCHOOL_CLIMATE", dataType: window.tableau.dataTypeEnum.int },
        { id: "SOCIAL_EMOTIONAL_HEALTH", dataType: window.tableau.dataTypeEnum.int },
        { id: "WELLNESS", dataType: window.tableau.dataTypeEnum.int },
        { id: "TRAUMA_INFORMED_PRACTICE", dataType: window.tableau.dataTypeEnum.int },
        { id: "COMMUNITY_HEALTH", dataType: window.tableau.dataTypeEnum.int },
        { id: "COMMUNITY_SCHOOLS", dataType: window.tableau.dataTypeEnum.int },
        { id: "CLOSING_THE_ACHIEVEMENT_GAP", dataType: window.tableau.dataTypeEnum.int },
        { id: "DRUG_FREE_COMMUNITIES", dataType: window.tableau.dataTypeEnum.int },
        { id: "LGBTQ_BASED_HARASSMENT", dataType: window.tableau.dataTypeEnum.int },
        { id: "MENTAL_HEALTH_SUPPORTS", dataType: window.tableau.dataTypeEnum.int },
        { id: "TUPE", dataType: window.tableau.dataTypeEnum.int },
        { id: "DISTRICT_AFTER_SCHOOL", dataType: window.tableau.dataTypeEnum.int },
        { id: "GANG_RISK_AWARENESS", dataType: window.tableau.dataTypeEnum.int },
        { id: "MILITARY_CONNECTED_SCHOOL", dataType: window.tableau.dataTypeEnum.int },
        { id: "RESILIENCE_YOUTH_DEVELOPMENT", dataType: window.tableau.dataTypeEnum.int },
        { id: "SAFETY_VIOLENCE", dataType: window.tableau.dataTypeEnum.int },
        { id: "SEXUAL_BEHAVIOR", dataType: window.tableau.dataTypeEnum.int },
        { id: "TOBACCO", dataType: window.tableau.dataTypeEnum.int },
        { id: "SUPPLEMENTAL_HEALTH", dataType: window.tableau.dataTypeEnum.int },
        { id: "SPECIAL_EDUCATION_SUPPORTS", dataType: window.tableau.dataTypeEnum.int },
        { id: "CUSTOM", dataType: window.tableau.dataTypeEnum.int },
        { id: "BLOCK", dataType: window.tableau.dataTypeEnum.string },
        { id: "SURVEYREGSUBMITTEDBY", dataType: window.tableau.dataTypeEnum.string },
        { id: "ROLE", dataType: window.tableau.dataTypeEnum.string },
        { id: "SURVEYTAKENDATE", dataType: window.tableau.dataTypeEnum.string },
        { id: "GENDER_IDENTITY_SEXUAL_ORIENTATION_BASED_HARASSMENT", dataType: window.tableau.dataTypeEnum.int },
        { id: "STUDENT_WELLNESS", dataType: window.tableau.dataTypeEnum.int }
      ],
      formatData: (data) =>
        data.map((item) => ({
          NAME: item.NAME || "",
          EMAILID: item.EMAILID || "",
          COUNTY: item.COUNTY || "",
          DISTRICT: item.DISTRICT || "",
          SURVEY_TYPE: item["SURVEY TYPE"] || "",
          SCHOOL_NAME: item["SCHOOL NAME"] || "",
          SCHOOL_ID: item["SCHOOL ID"] || "",
          CLOSEDATABY: item.closeDataBy || "",
          CLOSEDATAAT: item.closeDataAt || "",
          CLOSEDATACTION: item.closeDataction || 0,
          CORE_MODULE: item["CORE MODULE"] || 0,
          BEHAVIORAL_HEALTH: item["BEHAVIORAL HEALTH"] || 0,
          SCHOOL_CLIMATE: item["SCHOOL CLIMATE"] || 0,
          SOCIAL_EMOTIONAL_HEALTH: item["SOCIAL EMOTIONAL HEALTH"] || 0,
          WELLNESS: item.WELLNESS || 0,
          TRAUMA_INFORMED_PRACTICE: item["TRAUMA-INFORMED PRACTICE"] || 0,
          COMMUNITY_HEALTH: item["COMMUNITY HEALTH"] || 0,
          COMMUNITY_SCHOOLS: item["COMMUNITY SCHOOLS"] || 0,
          CLOSING_THE_ACHIEVEMENT_GAP: item["CLOSING THE ACHIEVEMENT GAP"] || 0,
          DRUG_FREE_COMMUNITIES: item["DRUG-FREE COMMUNITIES"] || 0,
          LGBTQ_BASED_HARASSMENT: item["LGBTQ-BASED HARASSMENT"] || 0,
          MENTAL_HEALTH_SUPPORTS: item["MENTAL HEALTH SUPPORTS"] || 0,
          TUPE: item.TUPE || 0,
          DISTRICT_AFTER_SCHOOL: item["DISTRICT AFTERSCHOOL"] || 0,
          GANG_RISK_AWARENESS: item["GANG RISK AWARENESS"] || 0,
          MILITARY_CONNECTED_SCHOOL: item["MILITARY-CONNECTED SCHOOL"] || 0,
          RESILIENCE_YOUTH_DEVELOPMENT: item["RESILIENCE & YOUTH DEVELOPMENT"] || 0,
          SAFETY_VIOLENCE: item["SAFETY & VIOLENCE"] || 0,
          SEXUAL_BEHAVIOR: item["SEXUAL BEHAVIOR"] || 0,
          TOBACCO: item.TOBACCO || 0,
          SUPPLEMENTAL_HEALTH: item["SUPPLEMENTAL HEALTH"] || 0,
          SPECIAL_EDUCATION_SUPPORTS: item["SPECIAL EDUCATION SUPPORTS"] || 0,
          CUSTOM: item.CUSTOM || 0,
          BLOCK: item.BLOCK || "",
          SURVEYREGSUBMITTEDBY: item.SURVEYREGSUBMITTEDBY || "",
          ROLE: item.ROLE || "",
          SURVEYTAKENDATE: item.surveyTakenDate || "",
          GENDER_IDENTITY_SEXUAL_ORIENTATION_BASED_HARASSMENT: item["GENDER IDENTITY & SEXUAL ORIENTATION-BASED HARASSMENT"] || 0,
          STUDENT_WELLNESS: item["STUDENT WELLNESS"] || 0
        }))
    };
  }

  // DCU Config
  return {
    url: `${config.basePath}coordinator/getDistrictExceltableau`,
    columns: [
      { id: 'COUNTY', dataType: window.tableau.dataTypeEnum.string },
      { id: 'DISTRICT', dataType: window.tableau.dataTypeEnum.string },
      { id: 'FUNDED', dataType: window.tableau.dataTypeEnum.string },
      { id: 'FIRST_NAME', dataType: window.tableau.dataTypeEnum.string },
      { id: 'LAST_NAME', dataType: window.tableau.dataTypeEnum.string },
      { id: 'EMAILID', dataType: window.tableau.dataTypeEnum.string },
      { id: 'PHONE', dataType: window.tableau.dataTypeEnum.string },
      { id: 'ADDRESS', dataType: window.tableau.dataTypeEnum.string },
      { id: 'CITY', dataType: window.tableau.dataTypeEnum.string },
      { id: 'ZIP_CODE', dataType: window.tableau.dataTypeEnum.string },
      { id: 'CNTYDISTID', dataType: window.tableau.dataTypeEnum.string },
      { id: 'CREATEDAT', dataType: window.tableau.dataTypeEnum.string },
      { id: 'APPROVEAT', dataType: window.tableau.dataTypeEnum.string },
      { id: 'APPROVE_STATUS', dataType: window.tableau.dataTypeEnum.string },
      { id: 'SUBMIT_STATUS', dataType: window.tableau.dataTypeEnum.string },
      { id: 'REPORT_ORDERED', dataType: window.tableau.dataTypeEnum.string },
      { id: 'TAKESURVEYDATE', dataType: window.tableau.dataTypeEnum.string },
      { id: 'APPROVEACTION', dataType: window.tableau.dataTypeEnum.string },
      { id: 'APPROVEBY', dataType: window.tableau.dataTypeEnum.string },
      { id: 'SURVEYREGSUBMITBY', dataType: window.tableau.dataTypeEnum.string },
      { id: 'SURVEYREGSUBMITAT', dataType: window.tableau.dataTypeEnum.string },
      { id: 'SURVEYREGSUBMITACTION', dataType: window.tableau.dataTypeEnum.string },
      { id: 'ORDERREPORTSUBMITBY', dataType: window.tableau.dataTypeEnum.string },
      { id: 'ORDERREPORTSUBMITAT', dataType: window.tableau.dataTypeEnum.string },
      { id: 'ORDERREPORTSUBMITACTION', dataType: window.tableau.dataTypeEnum.string }
    ],
    formatData: (data) =>
      data.map((item) => ({
        COUNTY: item.COUNTY || "",
        DISTRICT: item.DISTRICT || "",
        FUNDED: item.FUNDED || "",
        FIRST_NAME: item.FIRST_NAME || "",
        LAST_NAME: item.LAST_NAME || "",
        EMAILID: item.EMAILID || "",
        PHONE: item.PHONE || "",
        ADDRESS: item.ADDRESS || "",
        CITY: item.CITY || "",
        ZIP_CODE: item.ZIP_CODE || "",
        CNTYDISTID: item.CNTYDISTID || "",
        CREATEDAT: item.CREATEDAT || "",
        APPROVEAT: item.APPROVEAT || "",
        APPROVE_STATUS: item.APPROVE_STATUS || "",
        SUBMIT_STATUS: item.SUBMIT_STATUS || "",
        REPORT_ORDERED: item.REPORT_ORDERED || "",
        TAKESURVEYDATE: item.TAKESURVEYDATE || "",
        APPROVEACTION: item.APPROVEACTION || "",
        APPROVEBY: item.APPROVEBY || "",
        SURVEYREGSUBMITBY: item.SURVEYREGSUBMITBY || "",
        SURVEYREGSUBMITAT: item.SURVEYREGSUBMITAT || "",
        SURVEYREGSUBMITACTION: item.SURVEYREGSUBMITACTION || "",
        ORDERREPORTSUBMITBY: item.ORDERREPORTSUBMITBY || "",
        ORDERREPORTSUBMITAT: item.ORDERREPORTSUBMITAT || "",
        ORDERREPORTSUBMITACTION: item.ORDERREPORTSUBMITACTION || ""
      }))
  };
};
